import { useState } from "react";
import { Link, useLocation } from "wouter";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function LoginPage() {
  const [, setLocation] = useLocation();
  const { login } = useAuth();
  const [loginField, setLoginField] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await login(loginField, password);
      setLocation("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Ошибка входа");
    } finally {
      setPending(false);
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "var(--background, #0f1419)" }}
    >
      <Card className="w-full max-w-md border-[var(--sidebar-border)]" style={{ background: "var(--card)" }}>
        <CardHeader>
          <CardTitle>Вход</CardTitle>
          <CardDescription>Цифровой ДИАК ЗФ — закрытый портал</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            {error ? (
              <div className="text-sm text-red-600 dark:text-red-400" role="alert">
                {error}
              </div>
            ) : null}
            <div className="space-y-2">
              <Label htmlFor="login">Логин или email</Label>
              <Input
                id="login"
                autoComplete="username"
                value={loginField}
                onChange={(e) => setLoginField(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Пароль</Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={pending}>
              {pending ? "Вход…" : "Войти"}
            </Button>
            <p className="text-sm text-muted-foreground text-center">
              <Link href="/register" className="underline hover:text-foreground">
                Регистрация для приглашённых пользователей
              </Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
